/**
 * Official UTMify tracking scripts.
 * Loads the UTM parameter tracker and the UTMify pixel.
 * Safe to call multiple times — each script is only injected once.
 */

const UTM_SCRIPT_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'
const PIXEL_SCRIPT_SRC = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js'

declare global {
  interface Window {
    pixelId?: string
  }
}

function injectUtmTracker(): void {
  if (document.querySelector(`script[src="${UTM_SCRIPT_SRC}"]`)) return

  const script = document.createElement('script')
  script.src = UTM_SCRIPT_SRC
  script.setAttribute('data-utmify-prevent-xcod-sck', '')
  script.setAttribute('data-utmify-prevent-subids', '')
  script.async = true
  script.defer = true
  document.head.appendChild(script)
}

function injectUtmifyPixel(pixelId?: string): void {
  if (!pixelId) return
  if (document.querySelector(`script[src="${PIXEL_SCRIPT_SRC}"]`)) return

  window.pixelId = pixelId

  const script = document.createElement('script')
  script.src = PIXEL_SCRIPT_SRC
  script.async = true
  script.defer = true
  document.head.appendChild(script)
}

export function loadUtmify(pixelId?: string): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  injectUtmTracker()
  injectUtmifyPixel(pixelId)
}
